<template>
    <div
        id="bbva-form-2"
        class="p-4 md:p-6 shadow"
        :class="blueForm ? 'bg-light-blue' : 'bg-gray2'"
    >
        <div
            class="flex"
            :class="actualForm > 2 ? 'cursor-pointer' : 'cursor-default'"
            @click="onFormClick"
        >
            <div>
                <div
                    class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium"
                    :class="[blueForm ? ['bg-white'] : ['bg-light-blue', 'text-white']]"
                >2</div>
            </div>
            <div
                class="ml-4"
                :class="blueForm ? 'text-white' : ''"
            >
                <p class="text-lg sm:text-2xl font-medium leading-none xs:leading-tight">Domicilio personal</p>
                <p class="text-sm leading-tight mt-1 xs:mt-0">Recuerda que estos datos son obligatorios.</p>
            </div>
            <div class="ml-auto mt-2">
                <div
                    v-if="!blueForm"
                    :key="showForm"
                    :class="showForm ? 'triangle-up-black' : 'triangle-down-black'"
                ></div>
                <div
                    v-else
                    :key="showForm"
                    :class="showForm ? 'triangle-up-white' : 'triangle-down-white'"
                ></div>
            </div>
        </div>
        <div
            class="mt-4 form-2"
            :class="{'hidden': !showForm}"
        >
            <div class="line border-solid border-b border-gray3"></div>
            <ValidationObserver v-slot="{ handleSubmit }">
                <form
                    class="mt-4 xs:w-4/6 sm:w-5/6 lg:w-4/6 mx-auto leading-tight sm:leading-normal"
                    @submit.prevent="handleSubmit(onSubmit)"
                >
                    <div class="flex flex-col space-y-2">
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :classes="classes"
                                    :type="'text'"
                                    :name="'cp'"
                                    :value="formInputs.cp"
                                    @input="onCpChange"
                                >
                                    Código postal*
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'colony'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :loading="loading.zipCodeCatalogs"
                                    :options="catalogs.colonies"
                                    :waiting-text="'Escribe un CP válido para cargar las colonias'"
                                    v-model="formInputs.colony"
                                >
                                    Colonia*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'municipality'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :loading="loading.zipCodeCatalogs"
                                    :options="catalogs.municipalities"
                                    :waiting-text="'Escribe un CP válido para cargar los municipios/alcaldías'"
                                    v-model="formInputs.municipality"
                                >
                                    Municipio / Alcaldía*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :name="'state'"
                                    :type="'text'"
                                    :classes="classes"
                                    :value="stateText"
                                    :disabled="true"
                                >
                                    Estado*
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required|alpha_num_spaces|max:50"
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :classes="classes"
                                    :type="'text'"
                                    :name="'street'"
                                    :value="formInputs.street"
                                    @input="formInputs.street = formatInput($event)"
                                >
                                    Calle*
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <div class="flex flex-col space-y-2 w-full sm:w-1/2 sm:space-y-0 sm:flex-row sm:space-x-4 ">
                                <ValidationProvider
                                    class="sm:w-1/2"
                                    rules="required|alpha_num_spaces|max:5"
                                    v-slot="{ errors, classes }"
                                >
                                    <input-form
                                        :classes="classes"
                                        :type="'text'"
                                        :name="'out_num'"
                                        :value="formInputs.outNum"
                                        @input="formInputs.outNum = formatInput($event)"
                                    >
                                        Número exterior*
                                    </input-form>
                                    <span class="text-sm text-red">{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider
                                    class="sm:w-1/2"
                                    rules="alpha_num_spaces|max:5"
                                    v-slot="{ errors, classes }"
                                >
                                    <input-form
                                        :classes="classes"
                                        :type="'text'"
                                        :name="'int_num'"
                                        :value="formInputs.intNum"
                                        @input="formInputs.intNum = formatInput($event)"
                                    >
                                        Número interior
                                    </input-form>
                                    <span class="text-sm text-red">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'own_type'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :options="catalogs.ownTypes"
                                    :loading="loading.ownTypes"
                                    :disabled="disabled.ownTypes"
                                    v-model="formInputs.ownType"
                                >
                                    Régimen de vivienda*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required|month"
                                v-slot="{ errors, classes }"
                            >
                                <date-picker-form
                                    :classes="classes"
                                    name="residence_years"
                                    type="month"
                                    :value="formInputs.residenceYears"
                                    @change="formInputs.residenceYears = $event"
                                >
                                    Tiempo de residencia*
                                </date-picker-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <!-- <ValidationProvider
                                class="sm:w-1/2"
                                rules=""
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :classes="classes"
                                    :name="'city'"
                                    :value="formInputs.city"
                                    @input="formInputs.city = formatInput($event)"
                                >
                                    Ciudad
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider> -->
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'dom_type'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :options="catalogs.domTypes"
                                    :value="formInputs.domType"
                                    @input="onDomTypeChange"
                                >
                                    Tipo de domicilio*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="mt-6 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 items-center justify-end">
                        <button
                            type="button"
                            class="hyundai-button w-40 py-0 h-8 bg-light-blue"
                            @click="saveProgress"
                            :disabled="savingProgress"
                        >{{ !savingProgress ? 'Guardar avance' : 'Guardando...' }}</button>
                        <button
                            type="submit"
                            class="hyundai-button w-40 py-0 h-8"
                        >Siguiente</button>
                    </div>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
// Componentes para las validaciones del formulario
import {
    ValidationProvider,
    ValidationObserver,
    setInteractionMode,
} from "vee-validate";
setInteractionMode("eager");
// Validaciones personalizadas para el formulario
import "../helpers/form_validations";
import {
    getCatalog,
    getEnum,
    getZipCodeCatalogs,
} from "../helpers/helpers_functions";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: ["mainCheck", "actualForm", "savingProgress"],
    data() {
        return {
            showForm: false,
            formComplete: false,
            formInputs: {
                cp: "",
                colony: "",
                municipality: "",
                state: "",
                street: "",
                outNum: "",
                intNum: "",
                domType: "",
                city: "",
                residenceYears: "",
                ownType: "",
            },
            catalogs: {
                states: [],
                colonies: [],
                municipalities: [],
                domTypes: [],
                ownTypes: [],
            },
            loading: {
                states: false,
                domTypes: false,
                ownTypes: false,
                zipCodeCatalogs: false,
            },
            disabled: {
                ownTypes: false,
            },
            stateText: ''
        };
    },
    watch: {
        showForm(newVal) {
            if (newVal) {
                this.$emit("form-open", 2);
                $(".form-2").slideDown();
                if (this.emptyCatalog) {
                    this.getCatalogs();
                    this.getEnums();
                }
            } else {
                this.$emit("form-closed", 2);
                $(".form-2").slideUp();
            }
        },
    },
    methods: {
        getCatalogs() {
            this.loading.states = true;
            getCatalog("STATES_CUSTOMER")
                .then((resp) => {
                    this.catalogs.states = resp;
                    this.loading.states = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading.states = false;
                });
        },
        onFormClick() {
            if (this.mainCheck && !this.showForm && this.actualForm > 1) {
                this.$eventBus.$emit("hide-forms");
                this.showForm = true;
                this.formComplete = false;
            }
        },
        getEnums() {
            this.loading.ownTypes = true;
            getEnum("ownershipType")
                .then((resp) => {
                    this.catalogs.ownTypes = resp;
                    this.loading.ownTypes = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading.ownTypes = false;
                });

            this.loading.domTypes = true;
            getEnum("addressType")
                .then((resp) => {
                    this.catalogs.domTypes = resp;
                    this.loading.domTypes = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading.domTypes = false;
                });
        },
        onStreetChange(value) {
            // If the length of the value is less than or equal to 50
            // record the value, pass it to upercase and remove the accents
            // if not, it doesn't allow writing
            const regexp = /^[\w\d\s\,\.]{1,50}$/;
            this.formInputs.street = regexp.test(value)
                ? value
                      .toUpperCase()
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                : value.slice(0, -1);
            // this.formInputs.street = value
            //     .toUpperCase()
            //     .normalize("NFD")
            //     .replace(/[\u0300-\u036f]/g, "");
        },
        // onCityChange(value) {
        //     this.formInputs.city = value
        //         .toUpperCase()
        //         .normalize("NFD")
        //         .replace(/[\u0300-\u036f]/g, "");
        // },
        formatInput(value) {
            return value
                .toUpperCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
        },
        onDomTypeChange(value) {
            this.formInputs.domType = value;
            if (value.id === "WORK") {
                this.formInputs.ownType = "OTHER";
                this.disabled.ownTypes = true;
            } else {
                // this.formInputs.ownType = "";
                this.disabled.ownTypes = false;
            }
        },
        onCpChange(value) {
            // If the value is numeric and the length
            // is greater than or equal to 5 it record the value,
            // if not, it doesn't allow writing
            const regexp = /^[0-9]{1,5}$/;
            this.formInputs.cp = regexp.test(value)
                ? value
                : value.slice(0, -1);
            if (this.formInputs.cp.length === 5) {
                this.loading.zipCodeCatalogs = true;
                getZipCodeCatalogs(this.formInputs.cp)
                    .then((resp) => {
                        this.catalogs.colonies = resp.colonies;
                        this.catalogs.municipalities = resp.municipalities;
                        this.loading.zipCodeCatalogs = false;
                        if (resp.colonies.length === 1) {
                            this.formInputs.colony = resp.colonies[0].id;
                        }
                        if (resp.municipalities.length === 1) {
                            this.formInputs.municipality =
                                resp.municipalities[0].id;
                        }
                        if (resp.states.length === 1) {
                            if(resp.states[0].id == 'EM'){
                                resp.states[0].id = 'MC'
                            }
                            console.log(resp.states[0].id)
                            this.formInputs.state = resp.states[0].id;
                            this.stateText = resp.states[0].description
                        }
                    })
                    .catch((err) => {
                        console.err(err);
                        this.loading.zipCodeCatalogs = false;
                    });
            } else {
                this.catalogs.colonies = [];
                this.catalogs.municipalities = [];
                this.formInputs.colony = "";
                this.formInputs.municipality = "";
                this.formInputs.state = "";
            }
        },
        onSubmit() {
            if (!this.emptyCatalog) {
                // this.addInputsDesc();

                const formData = {
                    formNum: 2,
                    formInputs: { ...this.formInputs },
                };

                this.$emit("form-validated", formData);
            } else {
                this.$emit("charging-catalogs");
            }
        },
        saveProgress() {
            if (!this.emptyCatalog) {
                const formData = {
                    formNum: 2,
                    formInputs: { ...this.formInputs },
                };

                this.$emit("save-progress", formData);
            } else {
                this.$emit("charging-catalogs");
            }
        },
        setInputs(inputs) {
            if (inputs.zipCode) {
                this.onCpChange(inputs.zipCode);
            }
            // this.formInputs.cp = inputs.zipCode;
            this.formInputs.state = inputs.addresses_state_id;
            this.formInputs.street = inputs.addressName;
            this.formInputs.colony = inputs.colony_id;
            this.formInputs.outNum = inputs.exterior_number;
            this.formInputs.intNum = inputs.interior_number;
            this.formInputs.domType = inputs.addressType_id;
            this.formInputs.ownType = inputs.ownershipType_id;
            this.formInputs.residenceYears = inputs.residenceStartDate;
            this.formInputs.municipality = inputs.municipality_id;
            this.formInputs.city = ''; // inputs.city;
        },
    },
    computed: {
        emptyCatalog() {
            let empty = false;
            for (const key in this.catalogs) {
                if (!this.catalogs[key].length) {
                    empty = true;
                    break;
                }
            }
            return empty;
        },
        blueForm() {
            return this.formComplete && this.actualForm > 1;
        },
    },
    created() {
        this.$eventBus.$on("show-form-2", () => {
            this.showForm = true;
            this.formComplete = false;
        });
        this.$eventBus.$on("hide-forms", () => {
            this.showForm = false;
        });
        this.$eventBus.$on("complete-form-2", () => {
            this.showForm = false;
            this.formComplete = true;
        });
        this.$eventBus.$on("setFormsInputs", (inputs) => {
            this.setInputs(inputs);
        });
    },
};
</script>
